import React, { useEffect, useState } from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'
import { isIntervalFund } from '../../Helpers/CheckProductType'

export default function CapitalGainsDistributions({
  distributions,
  getDownload,
  fund,
}) {
  const [distributionInterval, setDistributionInterval] = useState()
  const [distributionsData, setDistributionsData] = useState()

  const intervals = distributions.value.productDetail.capitalGains
    .map((gains) => gains.year)
    .sort((a, b) => b - a)

  useEffect(() => {
    setDistributionInterval(intervals[0])
  }, [])

  useEffect(() => {
    let _distributionsData =
      distributions.value.productDetail.capitalGains.filter(
        (gains) => gains.year === distributionInterval
      )

    if (_distributionsData?.[0]?.capitalGainsData) {
      _distributionsData[0].capitalGainsData.sort((a, b) =>
        a.recordDate.localeCompare(b.recordDate)
      )
    }

    setDistributionsData(_distributionsData)
  }, [distributionInterval])

  function handleIntervalChange(event) {
    const selectedInvertal = event.target.value

    setDistributionInterval(selectedInvertal)
  }

  const onClickDownloadCapGains = (event) => {
    event.preventDefault()
    const capGainsParams = {
      type: isIntervalFund(fund.fundGroup)
        ? 'intervalProductDetail'
        : 'productDetail',
      period: distributionInterval,
      cusip: fund.cusip,
    }

    const _url = getDownload(capGainsParams)

    window.location = _url
  }

  function renderCapGainsDropdown() {
    return (
      <div
        className="Dropdown date-dropdown-template"
        id="cap-gains-date-dropdown"
      >
        <select className="Dropdown-menu" onChange={handleIntervalChange}>
          {intervals.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            )
          })}
        </select>
      </div>
    )
  }

  function renderDataPoint(data, unit) {
    return data === '-' ? data : unit === '$' ? unit + data : data + unit
  }

  function renderTableBody() {
    return (
      <>
        {distributionsData?.[0]?.capitalGainsData &&
          distributionsData[0].capitalGainsData.map((data) => {
            return (
              <tr className="Table-row" key={data.recordDate}>
                <td className="Table-cell u-textRight">
                  {formatDateStandard(data.recordDate)}
                </td>
                <td className="Table-cell u-textRight">
                  {formatDateStandard(data.exDivdndDate)}
                </td>
                <td className="Table-cell u-textRight">
                  {renderDataPoint(data.incomeDist, '$')}
                </td>
                <td className="Table-cell u-textRight">
                  {renderDataPoint(data.shortTermCapGain, '$')}
                </td>
                <td className="Table-cell u-textRight">
                  {renderDataPoint(data.longTermCapGain, '$')}
                </td>
                <td className="Table-cell u-textRight">
                  {renderDataPoint(data.totalCapGain, '$')}
                </td>
                <td className="Table-cell u-textRight">
                  {renderDataPoint(data.totalCapGainPct, '%')}
                </td>
              </tr>
            )
          })}
      </>
    )
  }

  return (
    <div
      className="Content u-borderColorNeutralLight u-marginBottom3gu u-paddingTop0"
      id="mf-distributions"
    >
      <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom1gu">
        <div className="Content u-sizeFit u-sm-marginBottom3gu u-sm-sizeFull">
          <h3 className="u-marginVert0" id="cap-gains-distributions-title">
            Distributions
          </h3>
        </div>
        <div className="Grid Grid--alignMiddle u-sizeFit">
          <div className="u-sizeFit u-sm-sizeFull">
            <button
              className="Button Button--tertiary u-padding2gu u-textNoTransform"
              onClick={onClickDownloadCapGains}
              data-analytics="download-cap-gains-distributions-details"
            >
              Download Capital Gains Distributions (csv)
            </button>
          </div>
          <div className="u-sizeFit u-sm-sizeFull u-sm-marginBottom1gu">
            {renderCapGainsDropdown()}
          </div>
        </div>
      </div>

      <div className="u-overflowX">
        <table
          className="Table Table--reversed Table--striped"
          id="mf-distributions-table"
        >
          <thead className="Table-head">
            <tr className="Table-row">
              <th className="Table-header" colSpan="3"></th>
              <th
                className="Table-header Table-header--bracketed u-textCenter"
                colSpan="4"
              >
                Breakdown of Capital Gains Distributions
              </th>
            </tr>
            <tr className="Table-row">
              <th className="Table-header u-textRight">Record Date</th>
              <th className="Table-header u-textRight">Ex/Payable Date</th>
              <th className="Table-header u-textRight">
                Ordinary Income Distribution
              </th>
              <th className="Table-header u-textRight">
                Short-term Capital Gains
              </th>
              <th className="Table-header u-textRight">
                Long-term Capital Gains
              </th>
              <th className="Table-header u-textRight">Total Capital Gains</th>
              <th className="Table-header u-textRight">% of Record Date NAV</th>
            </tr>
          </thead>
          <tbody className="Table-body">{renderTableBody()}</tbody>
        </table>
      </div>
    </div>
  )
}
